module.exports = __webpack_public_path__ + "static/media/FolderCircle.de085db2.svg";